module.exports = __webpack_public_path__ + "static/img/brees-2006-top-image-thumb.543acc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-top-image-thumb.jpg
// module id = 8Ayg
// module chunks = 1